export default {
      id: "participants-usage",
      viewBox: "0 0 21 22",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#participants",
      toString: function () {
        return this.url;
      }
    }